import React, { useMemo } from "react";
import styled from "styled-components";
import { Col, Csku, Row, useWindowSize } from "@commonsku/styles";
import { useSelector } from "react-redux";
import DashboardPageTitle from "../dashboard/DashboardPageTitle";
import { ReportProvider } from "../report/report_context";
import { getReportConfig, ReportConfig } from "../report/config";
import ActionMenu from "../report/action-menu/ActionMenu";
import ReportFiltersContainer from "../report/filters/ReportFiltersContainer";
import ReportTable from "../report/table/ReportTable";
import Pagination from "../report/table/Pagination";
import ActionBar from "../report/table/ActionBar";
import Loading from "../report/Loading";
import { EReportTypes, REPORT_TYPES } from "../report/routes/report_types";
import { getPopups } from "../../selectors";
import createPopup from "../../popup-factory";

const REPORT_TYPE = EReportTypes.PodProduction;

const ReportTableContainer = styled.div`
  position: relative;
`;

const PodProductionReport = () => {
  const popups = useSelector(getPopups);
  const windowHeight = useWindowSize()[1];

  const reportConfig: ReportConfig = useMemo(
    () => getReportConfig(REPORT_TYPE),
    [],
  );

  if (!reportConfig) {
    return null;
  }

  return (
    <ReportProvider reportConfig={reportConfig} containerHeight={windowHeight}>
      <Csku as={"div"} className="main-content csku-styles">
        <Row>
          <Col
            xs
            sm={10}
            style={{ display: "flex", alignItems: "center", paddingLeft: 8 }}
          >
            <DashboardPageTitle title={REPORT_TYPES[REPORT_TYPE].title} />
          </Col>
          <Col xs sm={2} padded end={1}>
            <ActionMenu />
          </Col>
        </Row>

        <ReportTableContainer>
          <ReportFiltersContainer />
          <ReportTable />
          <Pagination />
          <Loading />
        </ReportTableContainer>

        <ActionBar />
        {popups ? popups.map((p, idx) => createPopup(p, idx)) : null}
      </Csku>
    </ReportProvider>
  );
};

export default PodProductionReport;
